import React, { useState } from 'react';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';

const InputBox = ({
    icon: Icon,
    name,
    placeholder,
    onChange,
    onBlur,
    touched,
    error,
    type
}) => {
    const errorFlag = touched && error;
    const [showPassword, setShowPassword] = useState(false);

    const isPassword = type === 'password';
    const inputType = isPassword && showPassword ? 'text' : type;

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    return (
        <div>
            <div
                className={`border rounded-lg p-2 flex items-center gap-2 placeholder:text-sm ${errorFlag ? 'border-red-500' : ''
                    }`}
            >
                {Icon && <Icon className={`${errorFlag ? '!text-red-500' : '!text-gray-400'}`} />}
                <input
                    className="w-full self-stretch outline-none"
                    placeholder={placeholder}
                    name={name}
                    onChange={onChange}
                    onBlur={onBlur}
                    type={inputType}
                />
                {isPassword && (
                    <div
                        onClick={togglePasswordVisibility}
                        className="cursor-pointer text-gray-400"
                    >
                        {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                    </div>
                )}
            </div>
            {errorFlag && <p className="text-red-500 text-xs mt-1">{error}</p>}
        </div>
    );
};

export default InputBox;
